import { IMembro } from '@/@types/EstruturaOrganizacional';
import { ContainerMembros } from '@/components/shared/ContainerMembros';
import { Loading } from '@/components/shared/Loading';
import { MembroItem } from '@/components/shared/MembroItem';
import { api } from '@/services/api';
import { useEffect, useState } from 'react';


const ComposicaoCIPA = () => {

    const [composicaoCIPA, setComposicaoCIPA] = useState<IMembro[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getComposicaoCIPA = async () => {
            setIsLoading(true);
            const url = '/feagri/colegiados/orgao/sigla/CIPA';

            await api.get(url)
                .then(response => {
                    setComposicaoCIPA(response.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => setIsLoading(false));

        }

        getComposicaoCIPA();

    }, []);


    return (
        <>
            <h1>Composição CIPA</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <ContainerMembros>
                    {composicaoCIPA.map(representante => {
                            return (
                                <MembroItem 
                                    key={representante._id}
                                    data={{
                                    representanteFuncao: representante.funcao.funcaoweb,
                                    representanteNome: representante.representante.nome,
                                    representanteSubfuncao: representante.subfuncao?.subfuncaoweb,
                                    foto: representante.representante.foto
                                }} />
                            );
                    })}
                </ContainerMembros>
            )}

        </>
    );

}

export { ComposicaoCIPA };